var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "9bf8462a6a1f608556e4d8c8074244978b8d7c38"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["dodo-landing-page@delivery-hero-pm"] = {
  id: "9bf8462a6a1f608556e4d8c8074244978b8d7c38"
};